import React, { useState } from 'react';

// React DateTime
import Datetime from 'react-datetime';
import moment from 'moment';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';
import TeasuryTable from '../../../components/Content/TeasuryTable';

import { formatDateOnChange, formatThaiDateUi } from "../../../../utils/DateUtils";
import { parseCurrency } from '../../../../utils/SamuiUtils';

const Main = ({ name, dataMasterList, dataDetailList, onPageInsert, onPageUpdate }) => {
  const [filteredDetailList, setFilteredDetailList] = useState([]);
  const [whDocNo, setWhDocNo] = useState("");

  // เบิกจากคลัง
  const [fromWhId, setFromWhId] = useState("");
  const [fromWhName, setFromWhName] = useState("");

  // ไปยังรถ
  const [toWhId, setToWhId] = useState("");
  const [toWhName, setToWhName] = useState("");

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const handleChangeDate = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue = value && value instanceof moment ? value.format('YYYY-MM-DD') : value;

    if (name === 'fromDate') {
      setFromDate(formatDateOnChange(newValue));
    } else {
      setToDate(formatDateOnChange(newValue));
    }
  };

  const onRowSelected = (fromData) => {
    // พี่คินอยากให้กระพริบ เดี๋ยวไปร์ทจัดให้
    setFilteredDetailList([]);
    setWhDocNo("");
    setFromWhId("");
    setFromWhName("");
    setToWhId("");
    setToWhName("");

    setTimeout(() => {
      const filteredDetail = dataDetailList.filter(data => parseCurrency(data.WHDoc_Id) === fromData.WHDoc_Id);

      if (filteredDetail && filteredDetail.length > 0) {
        setFilteredDetailList(filteredDetail);
      } else {
        setFilteredDetailList([]);
      }

      setWhDocNo(fromData.WHDoc_No);
      setFromWhId(fromData.F_WH_Id);
      setFromWhName(fromData.F_WH_Name);
      setToWhId(fromData.T_WH_Id);
      setToWhName(fromData.T_WH_Name);
    }, 50);
  };

  // ทดสอบการทำค้นหาโดย SpriteZadis (ยังไม่สมบูรณ์ เดี๋ยวมาทำต่อ)
  const [searchItemTerm, setSearchItemTerm] = useState('');
  // const filterDataByDate = (data) => {
  //   const from = fromDate ? moment(fromDate, 'YYYY-MM-DD') : null;
  //   const to = toDate ? moment(toDate, 'YYYY-MM-DD') : null;

  //   const docDate = moment(data.WHDoc_Date, 'YYYY-MM-DD HH:mm:ss.SSS');
  //   const isWithinRange = (!from || docDate.isSameOrAfter(from, 'day')) &&
  //     (!to || docDate.isSameOrBefore(to, 'day'));

  //   return isWithinRange;
  // };
  const filteredItemData = dataMasterList.filter((data) => {
    // ตรวจสอบการค้นหาตามหมายเลขและชื่อประเภทเอกสาร
    const matchesItemSearchTerm =
      (data.WHDoc_No && data.WHDoc_No.toLowerCase().includes(searchItemTerm.toLowerCase())) ||
      (data.T_WH_Name && data.T_WH_Name.toLowerCase().includes(searchItemTerm.toLowerCase())) ||
      (data.Picking_No && data.Picking_No.toLowerCase().includes(searchItemTerm.toLowerCase()));

    // ตรวจสอบการกรองตามวันที่
    // const matchesDateRange = filterDataByDate(data);

    return matchesItemSearchTerm;
  });

  return <>
    <Breadcrumbs page={name} items={[
      { name: 'คลังสินค้า', url: '/Warehouse' },
      { name: name, url: '/bill-of-lading' },
    ]} />
    <div className="container-fluid card py-3 hidden-scrollbar" style={{ maxHeight: "80vh", overflowY: "auto" }}>
      <div className="row mb-2 align-items-center">
        <div className="col-2">
          <button
            className="btn text-white mx-3"
            onClick={() => onPageInsert()}
            style={{
              backgroundColor: 'rgb(239, 108, 0)',
              whiteSpace: 'nowrap',
              padding: '10px',
              fontSize: '15px'
            }}
          >
            <i className="fa fa-plus" aria-hidden="true"></i> {name}
          </button>
        </div>
        <div className="col-2">
          <div className="input-group">
            <span className="input-group-text">Search</span>
            <input
              type="text"
              className="form-control"
              value={searchItemTerm}
              onChange={(e) => setSearchItemTerm(e.target.value)}
            />
          </div>
        </div>
        {/* <div className="col-2">
          <div className="input-group">
            <span className="input-group-text">จากวันที่</span>
            <Datetime
              name="fromDate"
              value={fromDate || null}
              onChange={(date) => handleChangeDate(date, 'fromDate')}
              dateFormat="DD-MM-YYYY"
              timeFormat={false}
              inputProps={{ readOnly: true, disabled: false }}
            />
          </div>
        </div>
        <div className="col-2">
          <div className="input-group">
            <span className="input-group-text">ถึง</span>
            <Datetime
              name="toDate"
              value={toDate || null}
              onChange={(date) => handleChangeDate(date, 'toDate')}
              dateFormat="DD-MM-YYYY"
              timeFormat={false}
              inputProps={{ readOnly: true, disabled: false }}
            />
          </div>
        </div> */}
        <div className="col-8" />
      </div>
      <hr />
      <div className="row ">
        <div className="col-5 mb-1" style={{ borderRight: '2px solid #c7c8c9' }}>
          <div className="table-responsive" style={{ maxHeight: '650px', overflowY: 'auto' }}>
            <table id="basic-datatables" className="table table-striped table-hover">
              <thead className="thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '15%' }}>วันที่</th>
                  <th className="text-center" style={{ width: '15%' }}>เลขเอกสาร</th>
                  <th className="text-center" style={{ width: '30%' }}>รถส่งสินค้า</th>
                  <th className="text-center" style={{ width: '30%' }}>เลขที่ PK</th>
                  <th className="text-center" style={{ width: '10%' }}>
                    <i className="fa fa-edit" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredItemData.length > 0 ? (
                  filteredItemData.map((data, index) => (
                    <tr
                      key={data.WHDoc_Id || index + 1}
                      onClick={() => onRowSelected(data)}
                      style={{ cursor: 'pointer' }}>
                      <td className="text-center">{formatThaiDateUi(data.WHDoc_Date)}</td>
                      <td className="text-center">{data.WHDoc_No}</td>
                      <td className="text-center">{data.T_WH_Name}</td>
                      <td className="text-center">{data.Picking_No || '-'}</td>
                      <td className="text-center">
                        <button className="btn btn-sm" onClick={() => onPageUpdate(data.WHDoc_No)}>
                          <i className="fa fa-edit" />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">
                      <center>
                        <h5>ไม่พบข้อมูล</h5>
                      </center>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="col-7 mb-3">
          <div className="d-flex align-items-center bg-light p-3 rounded shadow-sm position-relative">
            <div className="flex-grow-1 text-center position-relative">
              <p className="card-title mb-0 fw-bold">
                เอกสารเลขที่: <span className="text-primary fw-bold fs-4">{whDocNo}</span>
              </p>
              <p className="mb-0 small">
                เบิกสินค้าจากคลัง: <span className="text-info fw-bold fs-5">{fromWhName}</span>
                <span className="mx-2">ไปยังรถ:</span>
                <span className="text-success fw-bold fs-5">{toWhName}</span>
              </p>
            </div>
          </div>
          <TeasuryTable dataList={filteredDetailList} />
        </div>
      </div>
    </div>
  </>;
};

export default Main;